import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav/Nav';
import Logo from "../../assets/images/logo.png";
import { StyledHeaderContainer } from './Header.styled';
import MobileNav from './Nav/MobileNav';
import GlobalChat from '../GlobalChat';
import { ChatInfoForm } from '../ModalsManager/Modals/ChatInfoForm';

const Header = () => {
    const [chatOpen, setChatOpen] = useState<boolean>(false);
    const [modalActive, setModalActive] = useState<string>("");
      
    return (
        <StyledHeaderContainer>
            <Link to="/"><img src={Logo} alt="logo"/></Link>
            <Nav setChatOpen={setChatOpen} />
            <MobileNav />
            <GlobalChat chatOpen={chatOpen} setChatOpen={setChatOpen} modalActive={modalActive} setModalActive={(active: string) => setModalActive(active)} />
            <ChatInfoForm modalActive={modalActive} setModalActive={setModalActive} />
        </StyledHeaderContainer>
    );
}

export default Header;
